const actions = [
  {
      title: 'Identify the change you would like to make.',
      text: 'Take some time to think about the change you would like to make. Try to keep this change simple, something small that you can easily integrate into your life.',
  },
  {
      title: 'Write down your pledge.',
      text: 'Writing down your pledge can boost your commitment to making a change. Think about using an “I will…” statement and words such as “strongly”, “committed” or “high priority” as this can increase motivation, making it more likely that you\'ll achieve your goal. (E.g. "I will prioritise making time to go for a walk every day this week”).',
  },
  {
      title: 'Make sure your pledge is realistic and sustainable.',
      text: 'Ask yourself: “is this pledge realistic and within reach?”, “do I have the time and resources to be able to make this change?”, “do I feel confident that I can achieve this?” You can always adjust your pledge to make it more or less challenging, or you can write a new one if needed.',
  },
  {
      title: 'Find somewhere to keep your pledge.',
      text: 'Having your pledge somewhere visible to you will help to keep it in your mind. Try putting it somewhere you\'ll see it frequently like a note on the mirror or the remote control, or in your purse/wallet. You may want to change it up and move your pledge to a different spot each week so that it\'s continually catching your eye.',
  },
];

const tip = 'Making a pledge can motivate you to achieve your goal. Writing it down and keeping it somewhere you\'ll see it every day like on a note in your purse/wallet will help you commit to change!';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
